import { Helmet } from "react-helmet-async";
import Navbar from "../components/Navbar";
import HeroSection from "../components/Hero";
import AboutSection from "../components/About";
import ServicesSection from "../components/Services";
import RealisationsSection from "../components/Realisations";
import ContactSection from "../components/Contact";
import Footer from "../components/Footer";

const Index = () => {
  return (
    <>
      <Helmet>
        <link rel="canonical" href="https://bartkiewiczmeble.pl" />
      </Helmet>

      <div className="min-h-screen bg-background dark">
        <Navbar />
        <main>
          <HeroSection />
          <AboutSection />
          <ServicesSection />
          <RealisationsSection />
          <ContactSection />
        </main>
        <Footer />
      </div>
    </>
  );
};

export default Index;